<template>
  <button
    class="close-button"
    :class="{ 'close-button--big': big }"
    @click="$emit('click')"
  >
    <img :src="img" alt="Close">
  </button>
</template>

<script>
export default {
  props: {
    big: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    img () {
      return this.big ? '/img/close-black.svg' : '/img/close.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
  .close-button {
    @include reset-button;

    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(#000, .25);

    transition: opacity $base-transition;

    &--big {
      background: transparent;
      width: 28px;
      height: 28px;

      img {
        display: block;
        width: 100%;
      }
    }

    &:hover {
      opacity: .85;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CloseButton.vue